module.exports = __webpack_public_path__ + "static/media/fff-magazine.281e893f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fff/fff-magazine.png
// module id = 44
// module chunks = 0